import { PartialUser, User, UserRole } from '../dto/User';

export const isAdmin = (u: User | PartialUser) => {
  return u.roles.includes('ROLE_ADMIN');
};

export const getRoleLabel = (r: UserRole) => {
  switch (r) {
    case 'ROLE_ADMIN':
      return 'Admin';
    case 'ROLE_USER':
      return 'User';
    case 'ROLE_CUSTOMER':
      return 'Customer';
    default:
      return '';
  }
};
